module.exports = __webpack_public_path__ + "img/img-parts-sishu02-2.cace5760.png";